/**
 * Models the report preferences for a report route.
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    _created: Date,
    name: String, // route name
    columns: ["string"],
    params: Object,
  },
  defaults: {
    _created: new Date(),
    name: null,
    columns: null,
    params: null,
  },
});

export { Model as default };
